import { render, staticRenderFns } from "./Third_mobile.vue?vue&type=template&id=2bc15945&scoped=true&"
import script from "./Third_mobile.vue?vue&type=script&lang=js&"
export * from "./Third_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Third_mobile.vue?vue&type=style&index=0&id=2bc15945&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc15945",
  null
  
)

export default component.exports